// extracted by mini-css-extract-plugin
module.exports = {"sCloseButton":"CloseButton_sCloseButton__K4fL6","open":"CloseButton_open__1QsK4"};